import { callWp } from './call-wp';

export type SkinType = 'light' | 'dark' | null;
export async function getSkinType() {
	const response = await callWp('GET', 'get_skin_type');

	if (!response) {
		// User is not signed in
		window.location.href = `${silkNexusWp.myAccountUrl}?redirect_to_booking=1`;

		return null;
	}

	return (response?.skinType ?? null) as SkinType;
}
